import { AllowanceModel } from '../../../../models/allowances/allowanceModel';
import { requests } from '../apiAgent';

export const AllowancesAPI = {
    getAll: () => {
        return requests
            .get('/dublin/api/v2/allowances/')
            .then((response: AllowanceModel[]) => response);
    },
};